import { ApolloError } from '@apollo/client'

import { DeviceType } from '@/graphql/generated/schemas'

import { Options } from '../../types/types'

const MIME_TYPE = 'text/csv'
export const DEVICE_TOAST_DURATION = 4000

export const deviceTypes: Options = [
  { label: 'Alarm', value: DeviceType.Alarm },
  { label: 'Camera', value: DeviceType.Camera },
  { label: 'Door', value: DeviceType.Door },
]

export const isValidFileType = (fl: FileList): boolean => {
  if (fl?.length === 0) {
    return true
  }
  return fl?.[0]?.type === MIME_TYPE
}

export const getErrorMessage = (e: ApolloError) => {
  const errorDetails = e?.graphQLErrors?.[0]?.extensions
  if (errorDetails?.code?.startsWith('csv.row')) {
    const rowNumber: number = errorDetails.details.rowIndex + 1
    return `Error in row ${rowNumber}: ${e.message}`
  } else {
    return e?.message ?? 'Cannot create devices'
  }
}

const BASE_HEADERS = 'device_type,name,facility_name,floor_name,external_id'

export const getPerTypeCSVTemplate = (
  deviceType: DeviceType,
  withAlarmType: boolean
): string => {
  switch (deviceType) {
    case DeviceType.Alarm: {
      const headers = withAlarmType
        ? `${BASE_HEADERS},alarm_type`
        : BASE_HEADERS
      const example = withAlarmType
        ? 'ALARM,Test Alarm 1,Headquarters,1st,ext-id-1,'
        : 'ALARM,Test Alarm 1,Headquarters,1st,ext-id-1'
      return [headers, example].join('\n')
    }
    case DeviceType.Door:
      return [BASE_HEADERS, 'DOOR,Test Door 1,Headquarters,1st,ext-id-1'].join(
        '\n'
      )
    case DeviceType.Camera:
      return [
        `${BASE_HEADERS},ip,mac_address,rtsp_path,rtsp_port,stream_protocol,stream_type`,
        'CAMERA,Test Camera 1,Headquarters,1st,ext-id-1,127.0.0.1,123,?camera,3333,RTSPS,ON_PREMISE',
      ].join('\n')
  }
}

export const getDeviceTypeMessage = (type: DeviceType) => {
  switch (type) {
    case DeviceType.Alarm:
      return 'alarms'
    case DeviceType.Camera:
      return 'cameras'
    case DeviceType.Door:
      return 'doors'
    default:
      return 'devices'
  }
}
